module.exports = __webpack_public_path__ + "static/media/mission-clear.5daad49d.wav";